import React, { useState, useRef, useEffect } from "react";
import { FiFilter, FiChevronDown, FiCheck } from "react-icons/fi";

const SchoolYearFilterDropdown = ({ selectedSchoolYear, setSelectedSchoolYear, schoolYears, setCurrentPage }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel =
    selectedSchoolYear === "ALL"
      ? "All School Years"
      : schoolYears.find((sy) => String(sy.id) === String(selectedSchoolYear))?.name || "All School Years";

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="flex items-center gap-2 bg-zinc-50 border border-zinc-200/80 hover:bg-zinc-100/80 rounded-lg px-2.5 py-1.5 text-xs text-zinc-800 transition-colors cursor-pointer focus:outline-none"
      >
        <FiFilter className="w-3.5 h-3.5 text-zinc-400 shrink-0" />
        <span className="font-medium">{selectedLabel}</span>
        <FiChevronDown className={`w-3.5 h-3.5 text-zinc-400 transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {isOpen && (
        <div className="absolute left-0 mt-1 w-48 bg-white border border-zinc-200 shadow-lg rounded-lg p-1 z-50 text-xs max-h-56 overflow-auto">
          <button
            type="button"
            onClick={() => {
              setSelectedSchoolYear("ALL");
              setCurrentPage(1);
              setIsOpen(false);
            }}
            className={`w-full flex items-center justify-between px-3 py-1.5 rounded-md text-left transition-colors cursor-pointer ${
              selectedSchoolYear === "ALL"
                ? "bg-zinc-100 text-zinc-900 font-bold"
                : "text-zinc-700 hover:bg-zinc-50 hover:text-zinc-900"
            }`}
          >
            <span>All School Years</span>
            {selectedSchoolYear === "ALL" && <FiCheck className="w-3.5 h-3.5 text-zinc-900" />}
          </button>

          {schoolYears.map((sy) => {
            const isSelected = String(selectedSchoolYear) === String(sy.id);
            return (
              <button
                key={sy.id}
                type="button"
                onClick={() => {
                  setSelectedSchoolYear(sy.id);
                  setCurrentPage(1);
                  setIsOpen(false);
                }}
                className={`w-full flex items-center justify-between px-3 py-1.5 rounded-md text-left transition-colors cursor-pointer ${
                  isSelected
                    ? "bg-zinc-100 text-zinc-900 font-bold"
                    : "text-zinc-700 hover:bg-zinc-50 hover:text-zinc-900"
                }`}
              >
                <span>{sy.name}</span>
                {isSelected && <FiCheck className="w-3.5 h-3.5 text-zinc-900" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default SchoolYearFilterDropdown;